import {lazyRegister} from '@/Core/lazyRegister';
import './tooltip-hover.component.css';
import template from './tooltip-hover.component.html';

class TooltipHoverController {
    static $inject = ['$element'];
    position: 'top' | 'bottom' | 'right' | 'left' = 'top';

    constructor(private $element) {
    }

    $onInit(): void {
        this.$element.addClass('tooltip-hover');
    }
}

export const TooltipHoverComponent: ng.IComponentOptions = {
    transclude: true,
    bindings: {
        tooltip: '@',
        position: '@?',
    },
    template: template,
    controller: TooltipHoverController
};

lazyRegister.component('tooltipHover', TooltipHoverComponent);